// reducers/test-maintenance/untouchables.js

// -- ADD -- //
export function addHasErrored(state = false, action) {
  switch (action.type) {
    case 'U_ADD_TEST_M_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function addIsLoading(state = false, action) {
  switch (action.type) {
    case 'U_ADD_TEST_M_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function add(state = {}, action) {
  switch (action.type) {
    case 'U_ADD_TEST_M_FETCH_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
}

// -- LIST -- //
export function untouchablesHasErrored(state = false, action) {
  switch (action.type) {
    case 'U_LIST_TEST_M_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function untouchablesIsLoading(state = false, action) {
  switch (action.type) {
    case 'U_LIST_TEST_M_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function untouchables(state = {}, action) {
  switch (action.type) {
    case 'U_LIST_TEST_M_FETCH_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
}